import React from "react";

// Official Looking4 company logo (provided by the client)
export default function Logo({ onClick, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`group flex items-center select-none ${className}`}
      aria-label="Looking4 accueil"
    >
      <span className="flex items-center justify-center rounded-xl bg-white px-2.5 py-1 shadow-sm transition-transform duration-300 group-hover:-translate-y-0.5">
        <img
          src="/assets/logo-officiel.png"
          alt="Looking4"
          className="h-16 w-auto object-contain"
          draggable="false"
        />
      </span>
    </button>
  );
}
